import React, {Fragment} from 'react';
import { Button, Card, CardBody, Container, Row, Col, Input, } from 'reactstrap';
import { TableStriped } from '../../../components/tables/TableStriped';
import { ModalCatMachineSanitarySanitaria } from '../../../components/worksheetsanitary/ModalCatMachineSanitarySanitaria';
import { useListMachineSanitary } from '../../../hooks/worksheetsanitary/useListMachineSanitary';
import { AlertDataTable } from '../../../components/tableDataTable/AlertDataTable';
import { TitleDataTable } from '../../../components/tableDataTable/TitleDataTable';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

export const IndexListMachinesSanitary = () => {
    const{
        catMachinesSanitary, descripcion,clave, validaciones,
        method, 
        handleInputChange, handleSearchSample, loading, 
        closeDialog, modal, modalTitle,
        handleCreate, saveCreate,
        handleUpdate, saveUpdate,
        handleDelete, saveDelete,
        nextPage, previousPage, goToPage, totalPageCount, currentPage,
        modalAlert, closeDeleteAlert,
        showDeleteAlert,
        handleExcelMachineSanitary, loadingExport, handleClearMicSample, handleSearch,
        searchMachineSanitary

    } = useListMachineSanitary();
    
    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "11px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
    };

    const actions = (rowData) => {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ gap: "3px", marginRight: "3px" }}>
                
                <Button 
                    color="primary" 
                    size="sm"
                    onClick={() => handleUpdate(rowData.id_machine_sanitary)}
                    disabled={loading}
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                    
                >
                    <i className="fa fa-edit"></i>
                </Button>


                <Button 
                    color="danger" 
                    size="sm"
                    onClick={() => handleDelete(rowData.id_machine_sanitary)}
                    disabled={loading}
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                >
                    <i className="fa fa-trash"></i>
                </Button>
            </div>
        );
    };

    return(
        <>
            <Fragment>
                <Container fluid={true} className='container-global-zoom'>
                    <Row>
                        <Col md="12">
                            <Card>
                                <CardBody className="p-1">
                                        <TitleDataTable
                                            titleTable="Listado de Equipos/Consumibles"
                                            buttonActions={handleExcelMachineSanitary}
                                            titleButton="Listado de sitios"
                                            isDisbled={loadingExport}
                                            loadingIsDisabled={loadingExport}
                                            titleCreate="Crear sitio"
                                            buttonActionsCreate={handleCreate}
                                            actionInput={handleSearch}
                                            valueFilter={searchMachineSanitary}
                                            filterLocalStorage={true}
                                            cleanFilterLocalStorage={handleClearMicSample}
                                        />
                                
                                        <div className="table-responsive">
                                            <DataTable
                                                value={catMachinesSanitary}
                                                paginator
                                                rows={15}
                                                responsiveLayout="scroll"
                                                rowsPerPageOptions={[15, 50, 100]} 
                                                className="data-table p-datatable-striped p-datatable-sm"
                                                emptyMessage={
                                                    <div className="text-center">
                                                        <img
                                                            src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                                            style={{ width: "32%" }}
                                                            alt="Sin resultados"
                                                        />
                                                        <br />
                                                        <p className="badge badge-light-primary mt-2" style={{ fontSize: "15px" }}>
                                                            No se encontraron resultados.
                                                        </p>
                                                    </div>
                                                }
                                            >
        
                                                <Column header="#" body={(rowData, options) => { const globalIndex = options.rowIndex; return globalIndex + 1; }} headerStyle={headerStyle} style={centerStyle} />
                                                <Column field="descripcion" header="Descripción" headerStyle={headerStyle} style={cellStyle} />
                                                <Column field="clave" header="Clave" headerStyle={headerStyle} style={cellStyle} />
                                                <Column header="Acciones" body={actions} exportable={false} headerStyle={headerStyle} style={centerStyle} />
                                            </DataTable>
                                        </div>
                                       
                                    
                                </CardBody>
                            </Card>
                            {showDeleteAlert && (
                                <AlertDataTable
                                    titleAlert="Eliminar equipos/consumible"
                                    visibleAlert={modalAlert}
                                    onHideAlert={closeDeleteAlert}
                                    sizeAlert="medium-dialog delete-method"
                                    messageAlert="Esta acción no se puede deshacer. ¿Estás seguro de eliminar el equipo/consumible?"
                                    alert1={true}
                                    titleAlert1={descripcion}
                                    buttonAcept
                                    titleNotLoading="Eliminar"
                                    titleDanger="Cancelar"
                                    actionAcept={saveDelete}
                                />

                            )}
                        </Col>
                    </Row>
                </Container>
                <ModalCatMachineSanitarySanitaria
                {
                    ...{
                        catMachinesSanitary, descripcion,clave, validaciones,
                        method, 
                        handleInputChange, handleSearchSample, loading, 
                        closeDialog, modal, modalTitle,
                        saveCreate, saveUpdate, saveDelete,
                        nextPage, previousPage, goToPage, totalPageCount, currentPage,
                    }
                }
                />
            </Fragment>
        </>
    )
}
